export default __webpack_public_path__ + "static/media/trowel.978b0397.svg";